import React, { useState, useContext, useCallback, useEffect } from 'react';
import { UserContext } from '../../../contexts/userProvider';
import { UsuariosContext } from '../../../contexts/usuariosProvider';
import LoadingSpinner from '../../Loader/load';
import BaseInput from '../../General/FormsComp/Input/BaseInput';
import BaseSelect from '../../General/FormsComp/Select/BaseSelect';
import BaseButton from '../../General/FormsComp/Button/BaseButton';

const niveisOptions = [
  { id: '1', nome: 'Básico' },
  { id: '2', nome: 'Gerente' },
  { id: '3', nome: 'Admin' },
];

const emptyForm = {
  name: '',
  email: '',
  password: '',
  nivel: '',
};

const Cadastro = ({ onTabChange }) => {
  const { setAlert } = useContext(UserContext);
  const { createUsuario, updateUsuario, usuarioEdit, setUsuarioEdit } = useContext(UsuariosContext);
  const [formData, setFormData] = useState(emptyForm);
  const [loading, setLoading] = useState(false);
  const isEditing = !!usuarioEdit;

  // Preencher formulário quando estiver editando
  useEffect(() => {
    if (usuarioEdit) {
      setFormData({
        name: usuarioEdit.name || '',
        email: usuarioEdit.email || '',
        password: '',
        nivel: String(usuarioEdit.nivel) || '',
      });
    } else {
      setFormData(emptyForm);
    }
  }, [usuarioEdit]);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSave = useCallback(async () => {
    if (!formData.name) {
      setAlert({ visible: true, title: "Atenção!", placeholder: "Nome é obrigatório", confirm: false, type: "warning" });
      return;
    }
    if (!formData.email) {
      setAlert({ visible: true, title: "Atenção!", placeholder: "Email é obrigatório", confirm: false, type: "warning" });
      return;
    }
    if (!isEditing && !formData.password) {
      setAlert({ visible: true, title: "Atenção!", placeholder: "Senha é obrigatória", confirm: false, type: "warning" });
      return;
    }
    if (!formData.nivel) {
      setAlert({ visible: true, title: "Atenção!", placeholder: "Nível é obrigatório", confirm: false, type: "warning" });
      return;
    }

    setLoading(true);
    try {
      let result;
      if (isEditing) {
        const updateData = {
          id: usuarioEdit.id,
          name: formData.name,
          email: formData.email,
          nivel: formData.nivel,
        };
        // Só envia senha se foi preenchida
        if (formData.password) {
          updateData.password = formData.password;
        }
        result = await updateUsuario(updateData);
      } else {
        result = await createUsuario(formData);
      }

      if (result) {
        setFormData(emptyForm);
        setUsuarioEdit(null);
        onTabChange('consulta');
      }
    } catch (error) {
      console.error('Erro ao salvar usuário:', error);
    } finally {
      setLoading(false);
    }
  }, [formData, isEditing, usuarioEdit, setAlert, createUsuario, updateUsuario, setUsuarioEdit, onTabChange]);

  const handleCancel = () => {
    setFormData(emptyForm);
    setUsuarioEdit(null);
    onTabChange('consulta');
  };

  return (
    <div className='usuario-cadastro-container'>
      {loading && <LoadingSpinner />}

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-vox-xl p-6 mb-6">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-6">
          {isEditing ? 'Editar Usuário' : 'Cadastrar Novo Usuário'}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <BaseInput
            label="Nome"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Digite o nome completo"
            required
          />

          <BaseInput
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="usuario@exemplo.com"
            required
          />

          <BaseInput
            label={isEditing ? "Nova Senha (deixe vazio para manter)" : "Senha"}
            name="password"
            type="password"
            value={formData.password}
            onChange={handleInputChange}
            placeholder={isEditing ? "Deixe vazio para manter a senha atual" : "Digite a senha"}
            required={!isEditing}
          />

          <BaseSelect
            label="Nível de Acesso"
            name="nivel"
            value={formData.nivel}
            onChange={handleInputChange}
            options={niveisOptions}
            placeholder="Selecione o nível"
            valueKey="id"
            labelKey="nome"
            required
          />
        </div>
      </div>

      <div className='flex justify-center gap-4 mt-6'>
        {isEditing && (
          <BaseButton
            onClick={handleCancel}
            variant="secondary"
            size="lg"
          >
            Cancelar
          </BaseButton>
        )}
        <BaseButton
          onClick={handleSave}
          disabled={loading}
          variant="primary"
          size="lg"
        >
          {loading ? 'Salvando...' : isEditing ? 'Atualizar Usuário' : 'Salvar Usuário'}
        </BaseButton>
      </div>
    </div>
  );
};

export default Cadastro;
